module.exports = __webpack_public_path__ + "roboto-latin-700-normal.227c93190fe7f82de3f802ce0b614d3b.hashedasset.woff2";